import React from 'react';
import UserClientTable from 'components/UserClientTable';

const User: React.FC = () => <UserClientTable />;

export default User;
